import type { ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { cn } from '@/lib/utils'

interface PageLayoutProps extends LayoutProps {
    className?: string
}

/**
 * The page body. Navigation, footer and the bag drawer live in the site chrome,
 * so a page only renders its own content here.
 */
export const Layout = ({ children, className }: PageLayoutProps): ReactNode => {
    return (
        <main id='main' className={cn('flex-1 pt-14 md:pt-16', className)}>
            {children}
        </main>
    )
}
